import React from "react";
import Spinner from "src/components/Spinner";
import { Button } from "src/components/ui/button";
import {
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
} from "src/components/ui/dropdown-menu";
import useBirthdayDropdownMenuHandler from "../hooks/useBirthdayDropdownMenuHandler";
import BirthdayDropdownMenuItem from "./BirthdayDropdownMenuItem";

interface BirthdayDropdownMenuContentProps {}

const BirthdayDropdownMenuContent: React.FC<
  BirthdayDropdownMenuContentProps
> = () => {
  const { summary, isLoading, handleViewDetail } =
    useBirthdayDropdownMenuHandler();

  return (
    <DropdownMenuContent className="w-[460px]" align="end">
      <DropdownMenuLabel className="text-xl text-darkBrown-default font-semibold">
        Birthday Notification
      </DropdownMenuLabel>

      <DropdownMenuGroup className="px-3">
        {!isLoading && summary ? (
          <>
            <BirthdayDropdownMenuItem
              birthdate="Today's"
              summary={summary.today}
            />
            <BirthdayDropdownMenuItem
              birthdate="Tomorrow"
              summary={summary.tomorrow}
            />
            <BirthdayDropdownMenuItem
              birthdate="Upcoming"
              summary={summary.upcoming}
            />
          </>
        ) : (
          <div className="flex items-center justify-center h-20">
            <Spinner />
          </div>
        )}
      </DropdownMenuGroup>
    </DropdownMenuContent>
  );
};

export default BirthdayDropdownMenuContent;
